'use client'

import { InputNumber } from '@/ui/components'

const SpotSanityNumberInput = ({
  number,
  setNumber
}: {
  number: number

  setNumber: (value: number) => void
}) => (
  <InputNumber
    value={number}
    onChange={(e) => setNumber(Number(e.target.value))}
  />
)

export default SpotSanityNumberInput
